// extracted by mini-css-extract-plugin
module.exports = {"label":"PersonalDataLabel_label__2JKqa","link":"PersonalDataLabel_link__6moe5"};